export default __webpack_public_path__ + "static/teammate0-208f1075890a558645c02d9746f2ce3b.png";